// extracted by mini-css-extract-plugin
export default {"block":"InputBlock_block__KIO+l","input":"InputBlock_input__8hjTA","button":"InputBlock_button__lbnwj"};